import React from "react";
import { Route, Switch } from "react-router-dom";
import { Redirect } from "react-router-dom/cjs/react-router-dom.min";
import { Path } from "enums";
import ShiftRecordsListPage from "./shift-records-list.page";
import ShiftRecordsDetailsModule from "modules/shift-records/shift-records-details/shift-records-details.module";
import DetailedTransactionHistoryModule from "modules/detailed-transaction-history-records/detailed-transaction-history.module";

const RecordsPage = () => {
  return (
    <Switch>
      <Route exact path={Path.ShiftRecords} component={ShiftRecordsListPage} />
      <Route exact path={Path.ViewShiftDetails} component={ShiftRecordsDetailsModule} />

      <Route
        exact
        path={Path.DetailedTransactionHistory}
        component={DetailedTransactionHistoryModule}
      />

      <Redirect to={Path.ShiftRecords} />
    </Switch>
  );
};

export default RecordsPage;
